import React from 'react'
import { Lang, ServiceProvider, UserProfileDto } from '../../services/api.types'
import { ROUTES } from '../../common/Routes/routePaths'
import { getServiceProviderLabel } from '../../common/helpers/formHelpers'
import { Dialog } from '@capacitor/dialog'
import { t } from 'ttag'
import { store } from '../../index'
import { push } from 'connected-react-router'
import { currentLang } from '../../i18nInit'

export interface IYumInsufficientPermissionsProps {
  userDto: UserProfileDto
  userIntegrationScopes: string
  special?: boolean
}

export default function YumInsufficientPermissions(props: IYumInsufficientPermissionsProps) {
  const { userDto, userIntegrationScopes, special } = props

  const { serviceProvider: serviceProviderRaw } = userDto
  const distanceScopeMissing =
    serviceProviderRaw === ServiceProvider.GOOGLE_FIT &&
    userIntegrationScopes &&
    !userIntegrationScopes.includes('https://www.googleapis.com/auth/fitness.location.read')

  if (!distanceScopeMissing) return <></>

  const distanceIntegrationUrl = `${ROUTES.INTEGRATION_PROXY.to}?type=${serviceProviderRaw}&scope=LEAN&d=1`
  const serviceProvider = getServiceProviderLabel(serviceProviderRaw)

  const text =
    currentLang === Lang.ET
      ? `Google pole veel meie rakendust distantsi sünkroonimiseks kinnitanud. Varsti näete vaadet, kus see kirjas on. Seal peate jätkamiseks vajutama lingile "Täpsemad" ja "Mine rakendusse YuMuuv (ebaturvaline)".`
      : `Google has not verified our app yet for syncing distance data. You will soon see a screen stating it. There you need to click "Advanced" and "Go to YuMuuv (unsafe)" to continue.`

  const handleGoogleFitUnverified = async () => {
    /*const { value: consent } = await Dialog.confirm({
      title: 'Google Fit',
      message: text,
      okButtonTitle: t`OK`,
      cancelButtonTitle: t`Cancel`,
    })
    if (!consent) return*/
    store.dispatch(push(distanceIntegrationUrl))
  }

  return (
    <div className="activity-index-info" style={special ? {} : { margin: '0 0 16px 0' }}>
      {special && <div>{t`Distance`}</div>}
      <span>{t`We seem to have insufficient permissions to sync with your ${serviceProvider} integration.`}</span>
      {` `}
      <a href={undefined} onClick={handleGoogleFitUnverified}>{t`Reauthorize`}</a>
    </div>
  )
}
